import script from "./tag-label.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./tag-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./tag-label.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./tag-label.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__